module.exports = __webpack_public_path__ + "static/media/smartcompressor.05e1b398.png";